import { SVGProps, FC } from 'react'

interface IProps extends SVGProps<SVGSVGElement> {}

const ArrowStrightRight: FC<IProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M12.0007 2.58008C7.61687 2.58008 3.70583 5.73104 2.78879 10.0218C2.33063 12.1657 2.63927 14.4454 3.66143 16.3854C4.64519 18.2523 6.25799 19.7612 8.18759 20.6163C10.1947 21.506 12.4989 21.661 14.6085 21.0543C16.6437 20.4692 18.4483 19.185 19.6769 17.461C22.2456 13.857 21.9021 8.7944 18.8801 5.56496C17.1089 3.67232 14.5932 2.58008 12.0007 2.58008ZM16.5197 12.5034L13.9517 15.1333C13.3015 15.7993 12.2738 14.7903 12.9213 14.1274L14.2171 12.8005H8.07647C7.64039 12.8005 7.27655 12.4364 7.27655 12.0006C7.27655 11.5647 7.64063 11.2006 8.07647 11.2006H14.1864L12.8649 9.87944C12.2083 9.2228 13.2264 8.20448 13.883 8.86112L16.5137 11.4915C16.7925 11.7702 16.7952 12.2214 16.5197 12.5034Z"
        fill="#13A767"
      />
    </svg>
  )
}

export default ArrowStrightRight
